export const GENERIC_STATUS_LABEL_DATA_ID_CONTRACT = {
  base: 'generic-status-label',
  container: '',
  icon: 'icon',
  status: 'status'
};
